import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { Input } from '@/components/Input.tsx'
import { Label } from '@/components/Label.tsx'
import { FormElement, FormElementError } from '@/components/templates/Form.tsx'

const useFieldError = (errors: z.ZodIssue[]) => {
  return (fieldName: string) => errors?.find((e) => e.path[0] === fieldName)
}

export const FormField = ({
  allErrors,
  defaultValue,
  fieldName,
  fieldType,
  trackFormInteraction,
}: {
  fieldName: string
  fieldType: string
  defaultValue?: string | number
  trackFormInteraction: (data: {
    action: 'click'
    formFieldName: string
  }) => void
  allErrors?: z.ZodIssue[]
}) => {
  const { t: tGeneral } = useTranslation('translation')
  const fieldError = useFieldError(allErrors || [])

  return (
    <FormElement>
      <Label htmlFor={fieldName}>{tGeneral(`fields.${fieldName}.label`)}</Label>
      <Input
        type={fieldType}
        name={fieldName}
        defaultValue={defaultValue}
        onFocus={() => {
          trackFormInteraction({
            action: 'click',
            formFieldName: fieldName,
          })
        }}
      />
      {fieldError(fieldName) && (
        <FormElementError>
          {tGeneral(`fields.${fieldName}.error`)}
        </FormElementError>
      )}
    </FormElement>
  )
}
